function ScreenManager()
{
	this.screens = {};
	this.current = null;
}

ScreenManager.prototype =
{
	transition: function(screenName)
	{
		if ( !(screenName in this.screens) )
		{
			return false;
		}
						
		var screen = this.screens[ screenName ];
		
		if ( screen === this.current )
		{
			return screen;
		}
		
		if ( this.current )
		{
			this.current.once('outroEnd', screen.intro, screen);
			this.current.outro();
		}
		else
		{			
			screen.intro();
		}
		
		this.current = screen;

		if ( Fullscreen.is() && window.localStorage )
		{
			localStorage.setItem( 'screen', screenName );
		}

		return screen;
	},
	get: function(screenName)
	{
		return this.screens[ screenName ];
	}
};